﻿/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class taskindex extends IceEntity {
    task_index_key = "";
    task_key = "";
    patient_trans_account = "";
    last_name = "";
    task_type: IceTypes.task_type = IceTypes.task_type.tasktypeOther;
    complete = false;
    start_date = NaN;
    due_date = NaN;
    from_login_user_name = "";
    to_login_user_name = "";
    subject = "";
    merged_trans_account = "";

    gettablename(): string {
        return "TASK_INDEX";
    }
}
